import { dateCustom } from '../../../../components';
import { paramsApi } from '../../../../helpers';
import api from '../../../../helpers/api';
import apiOld from '../../../../helpers/apiOld';
import apiV3 from '../../../../helpers/apiV3';
import { setFiltered } from '../../../../layout/redux/layoutActions';

const  generateDataName = (name, yrange) => {
    let y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    return { x: name, y: y };
}
const nLojas = 5
const labelsType = [ 'Satisfação geral', 'Insatisfação geral', 'Pilares', 'Indicadores' ]
const listSwots = [
  {
    id: 'forca',
    title: 'Força',
    labels: labelsType,
    type: { min: 0, max: 100 },
    lojas: Array(nLojas).fill().map((_, i)=> `Loja ${i+1}`)
  },
  {
    id: 'fraqueza',
    title: 'Fraqueza',
    labels: labelsType,
    type: { min: 0, max: 100 },
    lojas: Array(nLojas).fill().map((_, i)=> `Loja ${i+1}`)
  },
  {
    id: 'ameaca',
    title: 'Ameaça', 
    labels: labelsType,
    type: { min: 0, max:100 },
    lojas: Array(nLojas).fill().map((_, i)=> `Loja ${i+1}`)
  },
  {
    id: 'oportunidade',
    title: 'Oportunidade',
    labels: labelsType,
    type: { min: 0, max: 100 },
    lojas: Array(nLojas).fill().map((_, i)=> `Loja ${i+1}`)
  }
]

const listasMock = {
  swots: listSwots.map(l=> ({
    id: l.id,
    title: l.title,
    swot: l.labels.map(label=> ({
      name: label,
      data: l.lojas.map(loja=> {
        return generateDataName(loja,{ min: 0, max: 100 })
      })
    }))
  }))
}

export const setTotalAvaliacao = payload => ({
  type: 'INFO_SWOTS_TOTAL_AVALIACAO_P',
  payload
})

export const setFiltersProvisorio = payload => ({
  type: 'INFO_FILTERS_SWOTS_P',
  payload
})

export const putFiltersProvisorio = payload => ({
  type: 'CHANGE_FILTERS_SWOTS_P',
  payload
})

export const cleanFiltersProvisorio = () => ({
  type: 'CLEAN_FILTERS_SWOTS_P',
})


export const setListarSwots = payload => ({
  type: 'LIST_SWOTS_P',
  payload
})

export const setLoadList = payload => ({
  type: 'LOAD_LIST_SWOTS_P',
  payload
})

// export const listarSwots = e => {

//   return dispatch => dispatch([
//     setListarSwots(listasMock.swots),
//   ])

//   let params = paramsApi({})
//   return dispatch => {
//     api.get(`urlendpoint${params}`)
//     .then(result => {
//       dispatch(setListarSwots(result.data))
//     })
//     .catch(err => {
//         console.error(err);
//     });
//   }
// }

// export const filterHandle = ({projetoID, params, filterActive, typeSelect}) => {
//   return dispatch => dispatch([
//     setFiltered(params),
//     setListarSwots(listasMock.swots)
//   ])


//   let paramsf = paramsApi({})
//   return dispatch => {
//     api.get(`urlendpoint${params}`)
//     .then(result => {
//       dispatch([
//         setListarSwots(listasMock.graficos)
//       ])
//     })
//     .catch(err => {
//         console.error(err);
//     });
//   }
// }



export const filtersCustom = ({filters, typeSelect}) => {
  let paramsFilter = {}
  const dataAtual = new Date()
  if (typeSelect?.id === 'Ciclo') {
    if (filters?.ciclo?.mesAno) {
      paramsFilter = {
        intervalo: `${filters.ciclo.anoMes}`,
      }
    }
  }
  if (typeSelect?.id === 'Data') {
    paramsFilter = {
      intervalo: `${dateCustom(filters.dataInicial).data} ${dateCustom(filters.dataFinal).data}`,
    }
  }
  if (filters?.categoria?.categoriaId) {
    paramsFilter = {
      ...paramsFilter,
      categoriaId: filters.categoria.categoriaId,
    }
  }
  return paramsFilter
}


/*
const labelSwots = {
    forca: 'Força',
    ameaca: 'Ameaça',
    oportunidade: 'Oportunidade',
    fraqueza: 'Fraqueza',

    insatisfacaoGeral: 'Insatisfação geral',
    satisfacaoGeral: 'Satisfação geral',
    preco: 'Preço',
    atendimento: 'Atendimento',
    produto: 'Produto',
    indicadores: 'Indicadores',
    loja: 'Loja',
       
  }
*/


const listSCustomSwot = (e, nls = {}) => {

  // debugger;

  if (!e || typeof e !== 'object') {
    console.warn("Objeto de resposta inválido:", e);
    return [];
  }


  const labelSwots = {
    forca: nls.forca,
    ameaca: nls.ameaca,
    oportunidade: nls.oportunidade,
    fraqueza: nls.fraqueza,

    insatisfacaoGeral: nls.insatisfacaogeral,
    satisfacaoGeral: nls.satisfacaogeral,
    preco: nls.preco,
    atendimento: nls.atendimento,
    produto: nls.produto,
    indicadores: nls.indicadores,
    loja: nls.loja,
  };

  return Object.keys(e)
    .filter(key => key !== 'qtdeAvaliacoes' && e[key] !== null && e[key] !== undefined)
    .map(key => {
      const currentSwot = e[key] || {}; // se e[key] estiver indefinido, usa objeto vazio
      return {
        id: key,
        title: labelSwots[key] || key,
        swot: Object.keys(currentSwot)
          .filter(innerKey => currentSwot[innerKey] !== null && currentSwot[innerKey] !== undefined)
          .map(innerKey => {
            let infoResp = currentSwot[innerKey];
            if (typeof infoResp === 'string') {
              infoResp = infoResp.split(',');
            }
            return {
              id: innerKey,
              label: labelSwots[innerKey] || innerKey,
              info: infoResp
            };
          })
      };
    });
};



//Esta é a versão antiga que estava dando problema: quando clicava em Pesquisar retornava 0()
// Dentro do catch em setTotalAvaliacao(0) Vou deixar aqui somente para guardar o histórico em caso de problema
const listSCustomSwotOLD = (e, nls) => {

  const labelSwots = {
    forca: nls.forca, //'Força',
    ameaca: nls.ameaca, //'Ameaça',
    oportunidade: nls.oportunidade, //'Oportunidade',
    fraqueza: nls.fraqueza, // 'Fraqueza',

    insatisfacaoGeral: nls.insatisfacaogeral, //'Insatisfação geral',
    satisfacaoGeral: nls.satisfacaogeral, //'Satisfação geral',
    preco: nls.preco, //'Preço',
    atendimento: nls.atendimento, //'Atendimento',
    produto: nls.produto, //'Produto',
    indicadores: nls.indicadores, //'Indicadores',
    loja: nls.loja, //'Loja',
    
    
  }

  const swotList = Object.keys(e).filter(f=> f !== 'qtdeAvaliacoes').map(swot=> {
    return {
      id: swot, 
      title: labelSwots[swot],
      swot:  Object.keys(e[swot]).map(s=> {
        let infoResp = e[swot][s]
        if (typeof e[swot][s] === 'string') {
          infoResp = e[swot][s].split(',')
        }
        return {
          id: s,
          label: labelSwots[s],
          info: infoResp
        }
      }), 
    }
  })
  return swotList
}

export const listarSwots = ({
  projetoID,
  empresaId,
  grupo,
  //idioma1,
  filters={}, 
  typeSelect={}, 
  paginate = {pageNumber: 1, perPage: 7},
  idioma,
  nls
}) => {
  return dispatch => {
    dispatch(setLoadList(true))
    let params = paramsApi({
      projetoId: projetoID,
      // PageAtual: paginate.pageNumber?paginate.pageNumber:1,
      // RPP: paginate.perPage?paginate.perPage:7,
      grupo: grupo?.name,
      empresaId,
      //idioma:idioma1,
      ...filters,
      idioma
    })

    //apiOld.get(`/Front/GetSwot${params}`)
    apiV3.get(`/Front/GetSwotProdutos${params}`)
    .then(result => {
      /*
      const initialStatePaginate = { 
        pageNumber: result.data.pageAtual, 
        totalPages: result.data.totalPaginas,  
        totalElements: result.data.qtdeAvaliacoes, 
        perPage: result.data.rpp,
      }
        */
      //console.log("GETSWOTPRODUTOS", result.data)
      console.log("SEMERRO123-AVALIAÇÕES:", result.data.qtdeAvaliacoes)
      dispatch([
        // setListarSwots(listasMock.swots),
        setListarSwots(listSCustomSwot(result.data, nls)),
        // setPaginateComentarios(initialStatePaginate),
        setTotalAvaliacao(result.data.qtdeAvaliacoes),
        setLoadList(false)
      ])
    })
    .catch(err => {
        console.log("ERRO123", err);
        const initialStatePaginate = { 
          pageNumber: 1, 
          totalPages: 1,  
          totalElements: 0, 
          perPage: paginate.perPage
        }
        dispatch([
          setListarSwots([]),
          // setPaginateComentarios(initialStatePaginate),
          setTotalAvaliacao(0),
          setLoadList(false)
        ])
    });
  }
}

export const filterHandle = ({
  projetoID, 
  empresaId,
  grupo,
  params, 
  filtersProvisorio, 
  typeSelect, 
  paginate,
  idioma,
  nls
}) => {
  const paramsCustom = {...params, ciclo: params?.ciclo?.ano ? params.ciclo : filtersProvisorio.ciclo}
  //const idioma1 = idioma;
  let paramsFilter = filtersCustom({filters: paramsCustom, typeSelect})
  return dispatch => dispatch([
    setFiltered(paramsCustom),
    listarSwots({projetoID, empresaId, grupo, filters: paramsFilter, paginate, typeSelect, idioma, nls}),
  ])
}